import {
  Customizer,
  FocusTrapZone,
  FocusZone,
  ICommandBarItemProps,
  IFocusTrapZoneProps,
  ILayerProps,
  LayerHost,
  mergeStyles,
  Panel,
  PrimaryButton,
  Stack,
} from "@fluentui/react";
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import { CustomCommandBar } from "../../components/Generic/customCommandBar";
import { urlTelerik } from "../../services/http-common";
import { IconHelper } from "../../utils/Helper/iconHelper";
import ThemeBase from "../../utils/Theme/themeBase";
import { useId, useBoolean } from "@fluentui/react-hooks";
import React, { useEffect, useRef, useState } from "react";
import HeaderGeneric from "../../components/Generic/headerPanel";
import TokenService from "../../services/TokenService";
import { IExportarReporte } from "../../interfaces/base/IBase";
import reporteServicio from "../../services/reporteService";
import TablaReporte from "../../components/Table/TableReporte";
import ReporteBaseGenerico from "../../components/Generic/ReporteBaseGenerico";
import RepoteBaseGenerico from "../../components/Generic/ReporteBaseGenerico";
import { keyAccess } from "../../utils/Helper/helper";
import AuthService from "../../services/AuthService";
import CuadroMandoGenerico from "../../components/Generic/CuadroMandoTelerik";

const NameReport = "MOVGraficosPersonas.trdx";
const parameters: object = {
  GerenciaId: "51F64566-1C4F-4DAD-8C8B-18DDF702B1B3",
  other: "",
};

const CuadroPersona = () => {
  let t = TokenService.getToken();
  const viewerRef = useRef(); //equivalnete id de componente

  const [key, setKey] = useState(0);
  
  // useEffect(() => {
  //   EnviarToken();
  // }, [t]);

  const recargarComponente = () => {
    setKey(prevKey => prevKey + 1);
  };

  function descargarReporte() {
    const reporteExportar = {
      report: NameReport,
      Extension: "PDF"
    };
  
    reporteServicio.exportaReporte(reporteExportar)
      .then((response) => {
        if (response.status === 401 || response.status === 403) {
          localStorage.removeItem(keyAccess);
          AuthService.removeToken();
          window.location.assign("/login");
        }
        if (response.status === 200) {
          const dataUrl = response.data;

          const link = document.createElement('a');
          link.href = dataUrl;
          link.download = NameReport.split('.')[0] + '.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error("Status:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: recargarComponente,
    }
  ];

  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_PDF,
      onClick: () => {
        descargarReporte();
      },
    },
  ];

  // const EnviarToken = () => {
  //   var { viewerObject } =
  //     viewerRef.current != null ? viewerRef.current : viewerObject;
  //   viewerObject.authenticationToken(t);
  // };

  // useEffect(() => {
  //   const hideExportButton = () => {
  //     const exportButton: any = document.querySelector("#trv-main-menu-export-command");

  //     if (exportButton) {
  //       exportButton.remove();
  //       clearInterval(interval);
  //     }
  //   };

  //   const interval = setInterval(hideExportButton, 1);

  //   return () => clearInterval(interval);
  // }, [key]);

  return (
    <>
      <div className="ms-Grid" dir="ltr">
        <br />
        <div className="ms-Grid-row">
          <div style={{paddingLeft: "10px"}}>
            <TablaReporte
              title={"Cuadro Mando Personas"}
              subTitle={"Gestión de programaciones"}
              rigthBar={_farItems}
              leftBar={_items}
              horizontalAlign="start"
              iconName="BarChartVerticalFill"
            />
          </div>
          </div>
        <br />
      </div>

      <div key={key}>
        <CuadroMandoGenerico
          NameReport={NameReport}
          parameters={parameters}  // Pasando los parámetros como props
          scaleMode="FIT_PAGE_WIDTH"
        />
      </div>

        {/* <FocusTrapZone
          disabled={false}
          isClickableOutsideFocusTrap
          forceFocusInsideTrap={true}>
          <TelerikReportViewer
            ref={viewerRef}
            serviceUrl={urlTelerik}
            reportSource={{
              parameters: { editors: { multiSelect: parameters } },
              report: NameReport,
            }}
            viewerContainerStyle={ThemeBase.telerikStyle}
            viewMode="INTERACTIVE"
            scaleMode="FIT_PAGE_WIDTH"
            scale={1.0}
            enableAccessibility={false}
          />
        </FocusTrapZone> */}
    </>
  );
};
export default CuadroPersona;
